import React from "react";
import { useTranslation } from "react-i18next";

import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

import { cn } from "@/lib/utils/cn";
import {
  formatDateForTooltip,
  formatDateOnlyForTooltip,
  formatRelativeTime,
} from "@/utils/dateUtils";

type RelativeTimeProps = {
  date: Date | string | null | undefined;
  className?: string;
  tooltipDateOnly?: boolean;
  tooltipSide?: React.ComponentProps<typeof TooltipContent>["side"];
};

export function RelativeTime({
  date,
  className,
  tooltipDateOnly = false,
  tooltipSide,
}: RelativeTimeProps) {
  const { i18n } = useTranslation();

  if (!date) return null;

  const dateObj = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(dateObj.getTime())) return null;

  const relative = formatRelativeTime(dateObj, i18n.language);
  const tooltip = tooltipDateOnly
    ? formatDateOnlyForTooltip(dateObj, i18n.language)
    : formatDateForTooltip(dateObj, i18n.language);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <time
          dateTime={dateObj.toISOString()}
          className={cn("cursor-default", className)}
        >
          {relative}
        </time>
      </TooltipTrigger>
      <TooltipContent side={tooltipSide}>
        <p>{tooltip}</p>
      </TooltipContent>
    </Tooltip>
  );
}
